import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppGuard } from "./app.authguard";
import { ContaAppComponent } from "./conta/conta.app.component";
import { InicioComponent } from "./navegacao/inicio/inicio.component";
import { NotFoundComponent } from "./navegacao/not-found/not-found.component";

const rootRouterConfig: Routes = [
    { path: '', redirectTo: '/inicio', pathMatch: 'full' },
    {
        path: 'inicio',
        component: InicioComponent
    },

    {
        path: 'conta',
        loadChildren: () => import('./conta/conta.module')
            .then(m => m.ContaModule)
    },
    {
        path: 'questao',
        loadChildren: () => import('./questao/questao.module')
            .then(m => m.QuestaoModule)
    },
    { path: '**', component: NotFoundComponent } //manter sempre no fim da lista
];
@NgModule({
    imports: [
        RouterModule.forRoot(rootRouterConfig)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }